import client from './client';

// Lionjob (chỉ Giám đốc + mã code). Backend: /api/lionjob/... (DB tách riêng).
const BASE = '/lionjob/scraped-product-assignments';

// Mã code lưu tạm trong sessionStorage (mất khi đóng tab -> mở lại phải nhập mã).
export const getCode = () => sessionStorage.getItem('lionjob_code') || '';
export const setCode = (c) => sessionStorage.setItem('lionjob_code', c);
export const clearCode = () => sessionStorage.removeItem('lionjob_code');
// timeout 15s: nếu backend treo (vd server production chưa cấu hình DB matrixty) thì báo lỗi
// thay vì "mở khóa" im lặng mãi không phản hồi.
const hdr = () => ({ headers: { 'x-lionjob-code': getCode() }, timeout: 15000 });
// Riêng gọi Claude (sinh SEO) mất lâu hơn nhiều (Opus 4.8 + thinking + công thức Teeyoung),
// 15s không đủ -> dùng timeout 120s để không bị axios hủy giữa chừng.
const hdrGen = () => ({ headers: { 'x-lionjob-code': getCode() }, timeout: 120000 });

export const listAssignments = (params) => client.get(BASE, { params, ...hdr() }).then((r) => r.data.data);
export const listAccounts = () => client.get('/lionjob/scraped-product-assignments-accounts', hdr()).then((r) => r.data.data);
export const listProducts = (params) => client.get('/lionjob/scraped-products', { params, ...hdr() }).then((r) => r.data.data);
export const getAssignment = (id) => client.get(`${BASE}/${id}`, hdr()).then((r) => r.data.data);
export const updateAssignment = (id, body) => client.patch(`${BASE}/${id}`, body, hdr()).then((r) => r.data.data);
export const markDone = (id) => client.post(`${BASE}/${id}/done`, null, hdr()).then((r) => r.data.data);
export const generateSeo = (id) => client.post(`${BASE}/${id}/generate`, null, hdrGen()).then((r) => r.data.data);
export const createAssignment = (body) => client.post(BASE, body, hdr()).then((r) => r.data.data);
